module.exports = __webpack_public_path__ + "img/mandala-logo.95fa766c.png";